import { QueryFunctionContext } from '@tanstack/react-query'
import { GetCommunitiesReturnType, getCommunities } from 'API/CommunityService'
import { DocumentData, QueryDocumentSnapshot } from 'firebase/firestore'
import { Comunity } from 'resources/types'
import { AllowedOverrides } from './queryOptionsUtils.types'

export type getCommunitiesOptions = {
	sortBy: keyof Comunity;
	sort?: 'asc' | 'desc';
	limitNumber?: number;
	searchTerm?: string;
	lastDocument?: QueryDocumentSnapshot<DocumentData>;
	limitToRegion?: string;
	mode?: 'standard' | 'autocomplete';
};

export const queryKey = 'communities'
export const queryKeyAutocomplete = 'communities-autocomplete'

const getCommunitiesQueryOptions = ({
	sortBy,
	sort = 'asc',
	limitNumber,
	searchTerm,
	lastDocument,
	limitToRegion,
	mode = 'standard',
}: getCommunitiesOptions,
overrides?: AllowedOverrides) => ({
	queryKey: [
		queryKey, {
			sortBy, sort, limitNumber, searchTerm, lastDocument, limitToRegion,
		},
	],
	queryFn: async (context: QueryFunctionContext): Promise<GetCommunitiesReturnType<Comunity>> => {
		const pageParam = context.pageParam as QueryDocumentSnapshot<DocumentData> | undefined
		const finalSearchTerm = mode === 'autocomplete' ? (context?.meta?.searchTerm as string) ?? '' : searchTerm
		const result = await getCommunities(sortBy, sort, limitNumber, finalSearchTerm, pageParam, limitToRegion)
		return result
	},
	getNextPageParam: (lastPage: GetCommunitiesReturnType<Comunity>) => {
		if (limitNumber === undefined) {
			// If limitNumber is undefined, assume there's no limit and always return lastDocument
			return lastPage.lastDocument || null
		}
		// If the number of communities returned is less than the limit, there are no more pages
		return lastPage.payload.length < limitNumber ? undefined : lastPage.lastDocument || null
	},
	initialPageParam: lastDocument || undefined,
	// safe overrides
	staleTime: 30 * 1000, // Default stale time is 30 seconds
	...overrides,
})

export default getCommunitiesQueryOptions
